import React, { useRef } from 'react'
import { Link } from 'react-router-dom';

export default function ImageSlider({ items = [{ type: '', link: '' }], isHomePageSlider = false }) {

    const carouselItems = items.filter((item) => !!item?.link);

    return (
        carouselItems.length > 0 &&
        <div id="carouselExampleIndicators" className="carousel slide">
            {carouselItems.length > 1 &&
                <div className="carousel-indicators">
                    {carouselItems.map((item, index) => (
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={`${index}`} className={`${index == 0 ? 'active' : ''}`} aria-current="true" aria-label={`Slide ${index}`}></button>
                    ))}
                </div>
            }
            <div className="carousel-inner">
                {carouselItems.map((item, index) => (
                    item.type == 'img' ?
                        <Link to={item?.sliderLink ?? '#'} target={item?.isExternalLink ? '_blank' : '_self'} className={`carousel-item ${index == 0 ? 'active' : ''}`}>
                            <img src={item?.link} className="d-block w-100" alt={item?.link} style={{marginTop:15 , marginBottom:0}} />
                            {isHomePageSlider &&
                                <div class="carousel-caption d-none d-md-block">
                                    {<h5>{item?.title}</h5>}
                                    {<p>{item?.subTitle}</p>}
                                </div>
                            }
                        </Link> :
                        <div className={`carousel-item ${index == 0 ? 'active' : ''} `}>
                            <iframe width="100%" height="500" style={{ maxHeight: 460.5 }} src={item?.link} title="YouTube video player" frameborder="0" allow="muted; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen={"true"}></iframe>
                            {isHomePageSlider &&
                                <div class="carousel-caption d-none d-md-block">
                                    {<h5>{item?.title}</h5>}
                                    {<p>{item?.subTitle}</p>}
                                </div>
                            }
                        </div>
                ))}
            </div>

        </div >
    )
}
